import { render, staticRenderFns } from "./DomicilioNotificacion.vue?vue&type=template&id=4aea0c90"
import script from "./DomicilioNotificacion.vue?vue&type=script&lang=js"
export * from "./DomicilioNotificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aea0c90')) {
      api.createRecord('4aea0c90', component.options)
    } else {
      api.reload('4aea0c90', component.options)
    }
    module.hot.accept("./DomicilioNotificacion.vue?vue&type=template&id=4aea0c90", function () {
      api.rerender('4aea0c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/infoBase/DomicilioNotificacion.vue"
export default component.exports